import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLocationDropPininline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8 16C4 11.542 2 8.21 2 6a6 6 0 1 1 12 0c0 2.21-2 5.542-6 10zm0-8a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
		fill: "currentColor",
		fillRule: "evenodd"
	})
});
export default SvgLocationDropPininline;
